export default __webpack_public_path__ + "static/media/Fest2x.017249df.jpg";